import React, { useEffect, useState, useRef, useContext } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
// import "swiper/css";
// import "swiper/css/pagination";
import "./styles.css";
import * as _ from 'lodash';

// import required modules
import { Mousewheel, Pagination, Grid } from "swiper";

function GeneralSwiper(props) {
    // console.log(props, "these are props inside general swiper")
    const { allData: data, component, idColumn, sortKey } = props
    const Component = component
    if (data != undefined && data.length > 0) {
        const sortedData = sortKey != undefined ? _.sortBy(data, sortKey).reverse() : data;
        const deduplicatedData = _.uniqBy(sortedData, 'id');
        // console.log(sortedData, "this is sorted data")
        return (
            <>
                <Swiper
                    direction={"horizontal"}
                    slidesPerView={1}
                    spaceBetween={3}
                    mousewheel={true}
                    pagination={{
                        clickable: true,
                        dynamicBullets: true,
                    }}
                    breakpoints={{
                        640: {
                            slidesPerView: 2,
                            // spaceBetween: 2,
                        },

                        1150: {
                            slidesPerView: 3,
                            // spaceBetween: 2,
                        },
                        1460: {
                            slidesPerView: 4,
                            // spaceBetween: 2,
                        },
                    }}
                    modules={[Mousewheel, Pagination, Grid]}
                >
                    {deduplicatedData.map((record) => {
                        // console.log("record[idColumn]", record, record[idColumn])
                        return (
                            <SwiperSlide key={record[idColumn]}>
                                <Component key={record[idColumn]} data={record} {...props} />
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </>
        )
    } else {

        return "No data yet."
    }
}

export default GeneralSwiper;
